/* Pocket Tech search: build the same precise query for the drawer and results page. */
(function () {
  'use strict';
  const clean = value => String(value || '').trim().replace(/\s+/g, ' ').slice(0, 180);
  const phrase = value => 'title:"' + value.replace(/["\\:()]/g, ' ').trim() + '"';
  const words = value => value.split(' ').filter(Boolean).map(phrase).join(' AND ');
  function build(value) {
    const raw = clean(value);
    // Preserve explicit field syntax, including pagination/filter URLs generated by Shopify.
    if (!raw || /\b(?:title|tag|product_type|variants\.[\w]+|vendor|body):/i.test(raw)) return raw;
    let text = raw.toLowerCase().replace(/i\s+phone/g, 'iphone')
      .replace(/\b(iphone|pixel)\s*(\d+)/g, '$1 $2')
      .replace(/promax/g, 'pro max').replace(/(\d)(pro|max|plus|mini|ultra)\b/g, '$1 $2').replace(/one\s+plus/g, 'oneplus')
      .replace(/\b(samsng|samung)\b/g, 'samsung').replace(/\bipone\b/g, 'iphone')
      .replace(/\bpowerbank\b/g, 'power bank').replace(/\bair\s+pods\b/g, 'airpods');
    if (text === 'redmi or poco') return '(title:"redmi" OR title:"poco")';
    const caseIntent = /\b(cases?|covers?|designs?|printed|glossy|aesthetic)\b/.test(text);
    const charging = /\b(chargers?|adapters?|adaptors?|charging)\b/.test(text);
    if (charging && !caseIntent) {
      const rest = text.replace(/\b(chargers?|adapters?|adaptors?|charging)\b/g, '').trim();
      return '(title:"charger" OR title:"charging" OR title:"adapter" OR title:"adaptor") -title:"case" -title:"cover"' + (rest ? ' AND ' + words(rest) : '');
    }
    const accessory = /\b(cables?|earbuds?|airpods?|buds|power bank|watches?|smartwatch|headphones?|handsfree)\b/.test(text);
    if (accessory && !caseIntent) return words(text) + ' -title:"case" -title:"cover"';
    const model = text.match(/\b(iphone\s+\d{1,2}(?:\s+(?:pro max|pro|plus|mini))?|pixel\s+\d{1,2}a?(?:\s+(?:pro xl|pro|xl))?)\b/);
    if (model) {
      const base = model[1];
      const rest = text.replace(model[0], '').replace(/\b(apple|google|phone|mobile|cases?|covers?|for)\b/g, '').trim();
      let query = phrase(base);
      // A base model must not silently become its Pro/Plus/Mini sibling.
      if (/\d+a?$/.test(base)) ['pro', 'plus', 'mini', 'xl'].forEach(suffix => { query += ' -' + phrase(base + ' ' + suffix); });
      else if (/ pro$/.test(base)) ['max', 'xl'].forEach(suffix => { query += ' -' + phrase(base + ' ' + suffix); });
      return query + (rest ? ' AND ' + words(rest) : '');
    }
    // Keep Samsung A15/S24 tokens exact; never fuzz a model number into another model.
    text = text.replace(/\b([asfm])\s+(\d{2})(?=\b)/g, '$1$2');
    const design = /\b(goku|anime|naruto|luffy|gojo|gtr|porsche|ferrari|bmw|marvel|batman|avengers|coquette|aesthetic|floral|flower|gaming|gta)\b/.test(text);
    const phone = /\b(iphone|pixel|samsung|galaxy|xiaomi|redmi|poco|oneplus|oppo|vivo|realme|infinix|tecno|huawei|[asfm]\d{2})\b/.test(text);
    if (phone || design) text = text.replace(/\b(cases?|covers?|phone|mobile|for)\b/g, ' ').replace(/\s+/g, ' ').trim();
    if (/\bsamsung\b/.test(text)) text = text.replace(/\bgalaxy\b/g, '').replace(/\s+/g, ' ').trim();
    else if (/\bgalaxy\b/.test(text)) text = text.replace(/\bgalaxy\b/g, 'samsung');
    let query = words(text);
    const samsungModel = text.match(/\b(s\d{2})(?:\s+(ultra|plus|fe))?\b/);
    if (phone && samsungModel && !samsungModel[2]) {
      ['ultra', 'plus', 'fe'].forEach(suffix => { query += ' -' + phrase(samsungModel[1] + ' ' + suffix); });
    }
    if (design && !phone) query += ' AND (tag:"printed-all-models-live-v3" OR title:"For All Models")';
    return query;
  }
  function searchURL(value, action) {
    const url = new URL(action || (window.Shopify?.routes?.root || '/') + 'search', location.origin);
    url.search = '';
    url.searchParams.set('q', build(value));
    url.searchParams.set('type', 'product');
    url.searchParams.set('ptq', clean(value));
    url.searchParams.set('options[unavailable_products]', 'last');
    return url;
  }
  window.PocketTechSearch = {build, searchURL};
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, location.origin);
    if (!/\/search\/?$/.test(action.pathname) || action.searchParams.has('view')) return;
    const input = form.querySelector('[data-input-search], input[name="q"]');
    if (!input) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (clean(input.value)) location.assign(searchURL(input.value, action.href));
    else input.focus();
  }, true);
  function ready() {
    const current = new URL(location.href);
    if (!/\/search\/?$/.test(current.pathname) || current.searchParams.has('view') || current.searchParams.has('section_id')) return;
    const query = current.searchParams.get('q') || '';
    const precise = build(query);
    if (query && precise !== query) {
      current.searchParams.set('ptq', clean(query));
      current.searchParams.set('q', precise);
      current.searchParams.set('type', 'product');
      location.replace(current);
      return;
    }
    const label = current.searchParams.get('ptq');
    if (!label) return;
    document.querySelectorAll('[data-pt-search-value]').forEach(input => { input.value = label; });
    const heading = document.querySelector('#MainContent h1');
    if (heading) heading.textContent = 'Search results for “' + label + '”';
    document.title = 'Search: ' + label + ' – Pocket Tech';
    document.querySelectorAll('.t4s-active-filters__clear').forEach(link => {
      const url = new URL(link.href); url.searchParams.set('ptq', label); link.href = url.href;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
